import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`;

// Updated employeeService.js - fetchEmployees function
/**
 * Fetch employees with optional filtering
 * @param {Object} params - Query parameters for filtering
 * @returns {Promise} - Response with employee data and pagination info
 */
export const fetchEmployees = async (params = {}) => {
    try {
        const token = localStorage.getItem('token'); // Adjust if you're storing it elsewhere

        if (!token) {
            throw new Error('No token found. Please log in.');
        }

        const queryString = Object.entries(params)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        const response = await axios.get(`${API_URL}/all-employees?${queryString}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return {
            data: response.data.data,
            pagination: response.data.pagination
        };
    } catch (error) {
        console.error('Error fetching employees:', error);

        // Handle specific error cases
        if (error.response?.status === 403) {
            throw new Error(error.response.data.message || 'Access denied');
        } else if (error.response?.status === 404) {
            throw new Error('No employees found');
        }

        throw error;
    }
};

/**
 * Update an employee's information
 * @param {string} empId - Employee ID
 * @param {Object} employeeData - Updated employee data
 * @returns {Promise} - Response from the API
 */
export const updateEmployee = async (empId, employeeData) => {
    try {
        const response = await axios.put(`${API_URL}/employees/${empId}`, employeeData);
        return response.data;
    } catch (error) {
        console.error('Error updating employee:', error);
        throw error;
    }
};

/**
 * Delete an employee
 * @param {string} empId - Employee ID
 * @returns {Promise} - Response from the API
 */
export const deleteEmployee = async (empId) => {
    try {
        const response = await axios.delete(`${API_URL}/employees/${empId}`);
        return response.data;
    } catch (error) {

        console.error(
            'Error deleting employee:',
            error
        );

        throw new Error(

            error.response?.data?.message ||
            'Failed to delete employee'

        );

    }
};

/**
 * Change an employee's password
 * @param {Object} passwordData - Password data including employee ID
 * @returns {Promise} - Response from the API
 */
export const changeEmployeePassword = async (passwordData) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${API_URL}/changepassword`,
            passwordData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error changing password:', error);
        throw error;
    }
};

/**
 * Fetch registration details including locations and branches
 * @returns {Promise} - Response with location and branch data
 */
export const fetchRegDetails = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/regdetail`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return {
            location: response.data?.location || [],
            branch: response.data?.branch || []
        };
    } catch (error) {
        console.error('Error fetching registration details:', error);
        throw error;
    }
};
export const replaceEmployeeMapping =
    async (data) => {

        try {

            const response =
                await axios.put(

                    `${API_URL}/replace-employee-mapping`,
                    data

                );

            return response.data;

        }

        catch (error) {

            console.error(error);

            throw new Error(

                error.response?.data?.message ||
                "Failed to replace employee mapping"

            );

        }

    };